import { routes as worksheetRoutes } from './routes/worksheets';
import { routes as fileRoutes } from './routes/files';
import { routes as groupsRoutes } from './routes/groups';
import { routes as entitiesRoutes } from './routes/entities';
import { routes as workpapersRoutes } from './routes/workpapers';
import { routes as procedureTemplatesRoutes } from './routes/procedure-templates';
import { routes as usersRoutes } from './routes/users';
import { routes as internalCommentsRoutes } from './routes/internal-comments';
import { routes as industryRoutes } from './routes/industries';
import { routes as workpaperProceduresRoutes } from './routes/workpaper-procedures';
import { routes as clientQueriesRoutes } from './routes/client-queries';
import { routes as profileRoutes } from './routes/profile';

export const handlers = [
    ...worksheetRoutes,
    ...fileRoutes,
    ...groupsRoutes,
    ...entitiesRoutes,
    ...workpapersRoutes,
    ...procedureTemplatesRoutes,
    ...usersRoutes,
    ...industryRoutes,
    ...workpaperProceduresRoutes,
    ...internalCommentsRoutes,
    ...clientQueriesRoutes,
    ...profileRoutes,
];
